export default "__VITE_ASSET__ZW4dMwkm__"